<template>
	<section class="container-fluid banner-section">
		<div class="swiper-holder">
			<swiper :id="swiperId" class="swiper-desktop" :options="bannersOption">
				<swiper-slide v-for="banner in bannerFullWidth" :key="banner.id">
					<api-img :comp="banner.imagenes_id" :size="horizontalSize" />
				</swiper-slide>

				<div class="swiper-pagination" slot="pagination"></div>

				<div class="swiper-button-prev" slot="button-prev"></div>
				<div class="swiper-button-next" slot="button-next"></div>
			</swiper>
		</div>

		<div class="swiper-holder-mobile">
			<swiper :id="swiperMobile" class="swiper-mobile" :options="cBannersOption">
				<swiper-slide v-for="banner in bannerMovil" :key="banner.id">
					<api-img :comp="banner.imagenes_id" :size="verticalSize" />
				</swiper-slide>

				<div class="swiper-pagination-mob" slot="pagination"></div>

				<div class="swiper-button-prev-mob" slot="button-prev"></div>
				<div class="swiper-button-next-mob" slot="button-next"></div>
			</swiper>
		</div>
	</section>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
	name: 'LandingBanners',
	computed: {
		...mapGetters(['catalogosGetBanners']),
		cBannersOption() {
			return this.bannersOption = _.merge({}, this.bannersOption, {
				pagination: {
					el: '.swiper-pagination-mob',
					clickable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next-mob',
					prevEl: '.swiper-button-prev-mob'
				}
			})
		},
		bannerFullWidth() {
			return _.filter(this.catalogosGetBanners, { uso: (!this.footer) ? 'Web - Hero' : 'Web - Pie de página' })
		},
		bannerMovil() {
			return _.filter(this.catalogosGetBanners, { uso: (!this.footer) ? 'Dispositivos y vertical' : 'Web - Pie de página vertical' })
		},
		verticalSize() {
			return (!this.footer) ? '2427/1500' : '1080/750'
			// return (!this.footer)? '1618/1000' : '720/500'
		},
		horizontalSize() {
			return (!this.footer) ? '2880/672' : '1845/660'
		}
	},
	data: () => {
		return {
			slider: null,
			sliderMobile: null,
			sliderDesktop: null,
			sliderOptions: {},
			sliderMobileOptions: {},
			sliderDesktopOptions: {},
			swiperId: '',
			swiperMobile: '',
		}
	},
	props: {
		footer: {
			type: Boolean,
			default: false
		},
		bannersOption: {
			type: [Object],
			default: () => {
				return {
					loop: true,
					speed: 800,
					effect: 'fade',

					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},

					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},

					autoplay: {
						delay: 7000,
						disableOnInteraction: false
					}
				}
			}
		}
	},
	beforeMount() {
		this.swiperId = _.uniqueId('swiper-')
		this.swiperMobile = _.uniqueId('swiper-mobile-')
	}
}
</script>

<style lang="scss">
.banner-section {

	.swiper-holder-mobile,
	.swiper-holder {
		position: relative
	}

	.swiper-pagination-fraction,
	.swiper-pagination-custom,
	.swiper-horizontal>.swiper-pagination-bullets,
	.swiper-pagination-bullets.swiper-pagination-horizontal {
		/* bottom: var(--swiper-pagination-bottom, 8px); */
		bottom: var(--swiper-pagination-bottom, -34px);
	}

}
</style>